import { ref, computed } from 'vue'
import type { Ref } from 'vue'
import { useErpI18n } from '@/composables/useErpI18n'

export interface ControlItem {
  name: string
  type: string
  icon: string
}

export function useControlList(customList?: ControlItem[] | Ref<ControlItem[]>) {
  const { t } = useErpI18n()

  // 如果有自定义列表，直接返回
  if (customList) {
    if (Array.isArray(customList)) {
      if (customList.length > 0) {
        return { controlList: ref(customList) }
      }
    } else if (customList.value && customList.value.length > 0) {
      return { controlList: customList }
    }
  }

  // 创建响应式的带翻译的默认控件列表
  const controlList = computed(() => [
    { name: t('designer.controls.text'), type: 'text', icon: 'icon-wenbenkuai' },
    { name: t('designer.controls.longText'), type: 'longText', icon: 'icon-chaochangwenben' },
    { name: t('designer.controls.image'), type: 'image', icon: 'icon-tupian' },
    { name: t('designer.controls.emptyTable'), type: 'emptyTable', icon: 'icon-24gl-table' },
    { name: t('designer.controls.rect'), type: 'rect', icon: 'icon-juxing' },
    { name: t('designer.controls.hline'), type: 'hline', icon: 'icon-hengxian' },
    { name: t('designer.controls.vline'), type: 'vline', icon: 'icon-vertical_line' },
    { name: t('designer.controls.oval'), type: 'oval', icon: 'icon-tuoyuan' },
    { name: t('designer.controls.html'), type: 'html', icon: 'icon-html' },
    { name: t('designer.controls.barcode'), type: 'barcode', icon: 'icon-tiaoma' },
    { name: t('designer.controls.qrcode'), type: 'qrcode', icon: 'icon-erweima' },
  ])

  return { controlList }
}
